import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import React, { useEffect, useRef, useState } from "react";
import { BillableService } from "../../../services/billable-servise";
import './billable.css'
import { Toast } from 'primereact/toast';

import { Api } from "../../../services/api";
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Billable = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [billableList, setBillableList] = useState([]);

    const [billableColumnList, setBillableColumnList] = useState([]);


    const toast = useRef(null);
    useEffect(() => {
        // getBiliableData();
        getBiliableArchiveDataByYear();

    }, []);

    const getBiliableArchiveDataByYear = () => {
        console.log('getBiliableArchiveDataByYear')
        setIsLoading(true);
        // var _body = {
        //    year:2024


        // }

        var _body = {
            "startDate": localStorage.getItem('payPeriodStartDate'),
            "endDate": localStorage.getItem('payPeriodEndDate')

        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        // fetch(Api.API_BASE_URL + 'billable-pay-periods-by-year', {
        fetch(Api.API_BASE_URL + 'billable-pay-periods', {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {

                if (response.error !== '') {
                } else {

                    var data = response.result;
                    var x = BillableService.getDataBilible(data);
                    setBillableList(x);

                }

                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error:", error);
            });
        var t = BillableService.getBillableColumnData();
        setBillableColumnList(t);

    }


    const rowClass = (data) => {
        return {
            'bg-yellow-200': data.division === 'Total Field Operations' || data.division === 'Total Pre Con Estimating' || data.division === 'Total Interior Design' || data.division === 'Total Project Management' || data.division === 'Gross Pofit/Loss' || data.division === 'Total Property Management' || data.division === 'Total Sales & Marketing' || data.division === 'Total Administration' || data.division === 'Gross Pofit/Loss Field Ops, Pre Con, ID, & PM\'s' || data.division === 'Gross Pofit/Loss Administration',
            'bg-yellow-300': data.division === 'Total Field ops/ID/PM/Pre Con' || data.division === '' || data.division === 'Gross Profit/Loss' || data.division === 'Total labour burden billable vs unbillalbe Gross Profit or Loss'
        };
    };


    const headerTemplate = (data) => {
        var newStr = data.billableType;
        newStr = newStr.substring(1);
        const colSpanCount = billableColumnList.length > 0 ? billableColumnList.length : 12;
        
        return (
            <React.Fragment>
                <td colSpan={colSpanCount} className="myheader group-header-cell" style={{ border: 'none', background: '#f8fafc' }}>
                    <span className="group-header-text" style={{ display: 'block' }}>
                        {newStr}
                    </span>
                </td>
            </React.Fragment>
        );
    };

    const renderBodyTemplate = (col, value) => {
        if (col === 'mark_up_per' || col === 'unBillableTimePer') {
            return <span>{value.toFixed(1)}%</span>;
        }
        if (col === 'division' || col === 'name') {
            return <span>{value}</span>;
        }
        if (col === 'billableTime' || col === 'unBillableTime' || col === 'vacatiomStatTime' || col === 'eosTime' || col === 'salesTime' || col === 'sickTime' || col === 'totalHours') {
            if (value <= 0) {
                return <div >{value.toFixed(2)}</div>;

            } else {
                return <div>{value.toFixed(2)}</div>;
                // return <div className="bg-pink-100">{value.toFixed(2)}</div>;
            }
        }
        return <span>{priceBodyTemplatee(value)}</span>;
    };

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {
            return '';
        }
        const isNegative = rowData < 0; // Check if the value is negative
        return <span style={{ color: isNegative ? "red" : "black" }}>
            {formatCurrency(rowData)}
        </span>
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };



    return (
        <div className="dashboard-wrapper">
            <Toast ref={toast} />
            <div className="dashboard-content-card">
                {/* TOOLBAR */}
                <div className="dashboard-toolbar">
                    <div className="flex align-items-center gap-3">
                        <button type='button' onClick={() => { navigate(-1); }} className='btn-modern btn-secondary'>
                            <IoArrowBackSharp size={18} />
                            <span>Back</span>
                        </button>
                        <div className="flex flex-column">
                             <span className="text-xs font-bold text-500 uppercase" style={{ color: '#64748b', fontSize: '11px', fontWeight: 'bold' }}>Pay Period</span>
                             <span className="font-bold text-lg text-900" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                {localStorage.getItem('payPeriodStartDate')} — {localStorage.getItem('payPeriodEndDate')}
                             </span>
                        </div>
                    </div>
                </div>

                {isLoading ? (
                    <div className="loading-spinner">
                        <span>Loading Billable Data...</span>
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <div className="table-responsive-wrapper">
                        <DataTable 
                            value={billableList} 
                            rowClassName={rowClass} 
                            stripedRows 
                            showGridlines 
                            size="small"
                            className="p-datatable-sm compact-datatable" 
                            rowGroupMode="subheader" 
                            groupRowsBy="billableType" 
                            rowGroupHeaderTemplate={headerTemplate}
                            sortMode="single" 
                            sortField="billableType" 
                            sortOrder={1} 
                            scrollable 
                            scrollHeight="flex" 
                            selectionMode="single"
                            tableStyle={{ minWidth: '50rem' }}
                        >
                            {billableColumnList.map((col, i) => (
                                <Column
                                    field={col.value}
                                    frozen={i === 0 || i === 1}
                                    key={col.value}
                                    body={(e) => renderBodyTemplate(col.value, e[col.value])}
                                    bodyClassName={(rowData) => {
                                         // Check against known total rows to avoid applying archive text style
                                         const isTotalRow = 
                                            rowData.division === 'Gross Pofit/Loss' || 
                                            rowData.division === "Gross Pofit/Loss Field Ops, Pre Con, ID, & PM's" || 
                                            rowData.division === 'Gross Pofit/Loss Administration' || 
                                            rowData.division === 'LIDA Construction Gross Pofit/Loss' ||
                                            rowData.division === '';
                                         
                                         const isTimeColumn = ['billableTime','unBillableTime','vacatiomStatTime','eosTime','salesTime','sickTime','totalHours'].includes(col.value);

                                         return (isTimeColumn && !isTotalRow) ? 'archive-text' : '';
                                    }}
                                    header={col.name}
                                    style={i === 1 ? { textAlign: 'left', minWidth: '200px', fontWeight: 600, padding: '8px' } : i === 0 ? { minWidth: '300px', textAlign: 'left', fontWeight: 600, padding: '8px' } : { minWidth: '120px', textAlign: 'center', padding: '8px' }}
                                >
                                </Column>
                            ))}
                        </DataTable>
                    </div>
                )}
            </div>
        </div>
    )

}
export default Billable